import { NewOrderPanelStep } from './types'

export const MinimumGroupOrderSize = 2

/**
 * How far ahead a company can order. Mirrors the backend
 * (PreOrderHorizon.CompanyHorizonMonths) until pre-order settings expose it.
 */
export const CompanyOrderHorizonMonths = 6

/**
 * How far ahead a guest or private customer can order, today included.
 * Mirrors the backend (SalesConfigurations.PreOrderHorizonDays).
 */
export const GuestOrderHorizonDays = 7

export const NewOrderPanelStepOrder = {
  /** Started from a restaurant, e.g. on the restaurant list */
  RestaurantFirst: [
    NewOrderPanelStep.Restaurant,
    NewOrderPanelStep.Format,
    NewOrderPanelStep.Date,
    NewOrderPanelStep.Time,
    NewOrderPanelStep.OrderType,
  ],
  /** Started from a day in the company overview */
  DateFirst: [
    NewOrderPanelStep.Date,
    NewOrderPanelStep.Restaurant,
    NewOrderPanelStep.Format,
    NewOrderPanelStep.Time,
    NewOrderPanelStep.OrderType,
  ],
}

export const UpcomingOrdersPagination = {
  InitialLimit: 20,
  LoadMoreLimit: 10,
}
